/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.expo = window.expo || {};

expo.cacheSelectors = function () {
  expo.cache = {
    // General
    $w: $(window),
    $body: $('body'),
    $tabTrigger: $('.tab-switch__trigger'),
    $tabContent: $('.tab-switch__content'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Sidebar nav
    $sidebarDropdown: $('.sidebar-sublist'),
    $sidebarDropdownExpand: $('.sidebar-sublist__expand'),
    $sidebarDropdownContract: $('.sidebar-sublist__contract'),
    $sidebarSubLists: $('.sidebar-sublist__content'),
    $sidebarViewMore: $('.sidebar-module__viewmore'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note'
  }
};

expo.init = function () {
  expo.cacheSelectors();
  expo.mobileNav();
  expo.equalHeights();
  expo.sidebarViewMore();
  expo.sidebarDropdowns();
  expo.sidebarDropdownCheck();
  expo.tabSwitcher();
  expo.cartPage();
};

expo.mobileNav = function () {
  expo.cache.$mobileNavTrigger.on('click', function() {
    expo.cache.$mobileNav.slideToggle(220);
  });

  expo.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

expo.equalHeights = function () {
  expo.cache.$w.on('load', resizeElements());

  expo.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() {
    expo.cache.$productGridImages.css('height', 'auto').equalHeights();
    expo.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

expo.sidebarViewMore = function () {
  if (!expo.cache.$sidebarViewMore.length) {
    return;
  }

  expo.cache.$sidebarViewMore.on('click', function() {
    $(this).prev('.sidebar-module__list').toggleClass('sidebar-module__list--expand');
  });
};

expo.sidebarDropdowns = function () {
  if (!expo.cache.$sidebarDropdown.length) {
    return;
  }

  expo.cache.$sidebarDropdownExpand.on('click', function() {
    $(this).closest('.sidebar-sublist').addClass('is-open');
  });

  expo.cache.$sidebarDropdownContract.on('click', function() {
    $(this).closest('.sidebar-sublist').removeClass('is-open');
  });

};

expo.sidebarDropdownCheck = function () {
  if (!expo.cache.$sidebarSubLists.length) {
    return;
  }

  expo.cache.$sidebarSubLists.each(function() {
    var $el = $(this);
    if ($el.find('.is-active').length) {
      $el.parent('.sidebar-sublist').addClass('is-open');
    }
  });

};

expo.tabSwitcher = function () {
  if (!expo.cache.$tabTrigger.length) {
    return;
  }

  var $trigger = expo.cache.$tabTrigger,
      $content = expo.cache.$tabContent,
      $el,
      link;

  // Hide extra content areas with JS and set active tab
  $content.filter(':gt(0)').addClass('is-hidden');
  $trigger.first().addClass('is-active');

  $trigger.on('click', function(evt) {
    evt.preventDefault();
    // set active tab
    $trigger.removeClass('is-active');
    $el = $(this).addClass('is-active');

    // hide all content areas, then show desired one
    link = $el.data('link');
    $content.addClass('is-hidden');
    $content.filter('[data-content="' + link + '"]').removeClass('is-hidden');
  });
};

expo.cartPage = function () {
  

  expo.cache.$body.on('click', expo.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(expo.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

// Initialize expo's JS on docready
$(expo.init)

// Added by Andrew E February 22 2019
$(document).ready(function() {
  $('.header-bar__module.header-bar__search ').insertAfter('.row.mob-hide');
});